import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

import svgArrowDown from './Arrow.svg?raw';

const DEBUG_VERBOSE: boolean = false;
export const HHDSButtonHeroTagName: string = 'hhds-button-hero';
const TAG_NAME: string = HHDSButtonHeroTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSButtonHeroAttrNames = {
	Mode: 'mode',
};

const Attrs = HHDSButtonHeroAttrNames;

export enum HHDSButtonHeroMode {
	Dark = 'dark',
	Light = 'light',
}

export class HHDSButtonHero extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const mode = this.vars.get<typeof HHDSButtonHeroMode>(Attrs.Mode);

		const html: string = /* html */ `
      <button class="${TAG_NAME}" mode="${mode}" aria-label="Skip to content">${svgArrowDown}</button>
    `;

		// Helper/tidiness method for defining this.shadow.innerHTML with
		// global styles and component styles prefixed to the supplied HTML.
		// Using this universally would ensure that we can easily alter this
		// structure across all components.
		this.setInnerHtml('', '', html);

		this.observeSlotChanges(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	[Attrs.Mode]: {
		description: 'Controls appearance of button',
		defaultValue: HHDSButtonHeroMode.Dark,
		type: HHDSButtonHeroMode,
	},
};
